import { PatientApplicantEditDrawer } from '@app/icare/entities/patient/edits/PatientApplicantEditDrawer'
import { patientApplicantQueries } from '@app/icare/entities/patient/queries/patientApplicantQueries'
import { patientFindingsQueryOptions } from '@app/icare/entities/patient/queries/patientFindingsQueryOptions'
import type { PatientApplicantRelation } from '@app/icare/entities/patient/schema/PatientApplicant'
import { PatientId } from '@app/icare/entities/patient/schema/PatientId'
import { RelationTabs } from '@app/icare/routes/_app/patienten/$id/_edit/-components/RelationTabs'
import { isActivePatientRelation } from '@app/icare/shared/api/form.type'
import { t } from '@lingui/core/macro'
import { entityParams } from '@pkg/db/utils'
import { useQuery, useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { useRelationCommitNavigation } from '../-components/useRelationCommitNavigation'

export const Route = createFileRoute('/_app/patienten/$id/_edit/_applicant/anmelder')({
  params: entityParams({ id: PatientId }),
  loader: ({ params, context: { queryClient } }) =>
    Promise.all([
      queryClient.ensureQueryData(patientApplicantQueries.forTabs(params.id)),
      queryClient.ensureQueryData(patientFindingsQueryOptions(params.id)),
    ]),
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()
  const navigate = Route.useNavigate()
  const { data: applicants = [] } = useSuspenseQuery(patientApplicantQueries.forTabs(id))
  const { data: findings = [] } = useQuery(patientFindingsQueryOptions(id))
  const { data: totalCount } = useQuery(patientApplicantQueries.totalCount(id))

  const handleAfterCommit = useRelationCommitNavigation<PatientApplicantRelation>({
    isInactive: relation => !isActivePatientRelation(relation),
    onCreateNavigate: relation =>
      navigate({
        to: '/patienten/$id/anmelder/$relation',
        params: { id, relation: relation.id as never },
      }),
    onInactiveEditNavigate: () => navigate({ to: '.', replace: true }),
  })

  return (
    <RelationTabs
      relations={applicants}
      basePath={`/patienten/${id}/anmelder`}
      findings={findings}
      findingsGroup="applicants"
      onAdd={params =>
        void PatientApplicantEditDrawer.show({ patientId: id, onAfterCommit: handleAfterCommit, ...params })
      }
      addLabel={t`Anmelder hinzufügen`}
      relationTotalCount={totalCount}
    />
  )
}
